import { render, staticRenderFns } from "./DocumentProperties.vue?vue&type=template&id=08419bb4&scoped=true"
import script from "./DocumentProperties.vue?vue&type=script&lang=ts"
export * from "./DocumentProperties.vue?vue&type=script&lang=ts"
import style0 from "./DocumentProperties.vue?vue&type=style&index=0&id=08419bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08419bb4",
  null
  
)

export default component.exports